import { textStyleCss } from 'src/theme/atlas';
import styled from 'styled-components';

export const StatusBoxRow = styled.div`
  display: flex;
  flex-direction: row;
  @media (max-width: 800px) {
    width: 90%;
    justify-content: space-between;
  }
`;

export const StatusBoxExpiring = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 90%;
  max-width: 140px;
  height: 30px;
  ${({ theme }) => textStyleCss(theme.atlas.typography.semantic.caption)}
  font-weight: 600;
  background: ${(props) =>
    props.theme.atlas.semantic.color.status.warning.default};
  color: ${(props) => props.theme.atlas.semantic.color.type.inverse};
  border-radius: 4px;
  @media (max-width: 400px) {
    max-width: 120px;
  }
`;

export const StatusBoxNotInvited = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 90%;
  max-width: 140px;
  height: 30px;
  ${({ theme }) => textStyleCss(theme.atlas.typography.semantic.caption)}
  font-weight: 600;
  background: ${(props) => props.theme.atlas.semantic.color.type.default};
  color: ${(props) => props.theme.atlas.semantic.color.type.inverse};
  border-radius: 4px;
  @media (max-width: 400px) {
    max-width: 120px;
  }
`;

export const StatusBoxAction = styled.div`
  margin-left: 10px;
  ${({ theme }) => textStyleCss(theme.atlas.typography.semantic.body)}
  color: ${(props) => props.theme.atlas.semantic.color.action.primary.default};
  display: flex;
  height: 100%;
  align-items: center;

  &:hover {
    cursor: pointer;
  }
`;

export const StatusBoxInfo = styled.div`
  ${({ theme }) => textStyleCss(theme.atlas.typography.semantic.caption)}
  color: ${(props) => props.theme.atlas.semantic.color.type.muted};
  max-width: 300px;
  @media (max-width: 800px) {
    max-width: 100%;
  }
`;

export const StatusBoxInvited = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 90%;
  max-width: 140px;
  height: 30px;
  ${({ theme }) => textStyleCss(theme.atlas.typography.semantic.caption)}
  font-weight: 600;
  background: ${(props) => props.theme.atlas.semantic.color.type.default};
  color: ${(props) => props.theme.atlas.semantic.color.type.inverse};
  border-radius: 4px;
  @media (max-width: 400px) {
    max-width: 120px;
  }
`;

export const StatusBoxDeactivated = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 90%;
  max-width: 140px;
  height: 30px;
  ${({ theme }) => textStyleCss(theme.atlas.typography.semantic.caption)}
  font-weight: 600;
  background: ${(props) => props.theme.atlas.semantic.color.type.muted};
  color: ${(props) => props.theme.atlas.semantic.color.type.inverse};
  border-radius: 4px;
  @media (max-width: 400px) {
    max-width: 120px;
  }
`;

export const AppToggleContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-content: space-between;
`;
